<template>
    <v-row>
        <v-dialog v-model="showDialog" fullscreen scrollable persistent no-click-animation style="z-index: 1005;">        
        <!--<v-skeleton-loader
        v-if="apiLoading"
          type="article, actions"
        ></v-skeleton-loader>-->
        <v-card>
            <!--<v-card-title class="px-2 py-0">
                <v-col cols="12" class="d-flex justify-space-between align-center">
						<h4>
							{{ $t('wkt.admin.expensesheetitem.title') }}
						</h4>
						<v-btn icon @click="close()">
							<v-icon>close</v-icon>
						</v-btn>
                </v-col>
                            <span style="font-size: 20px;">
                                {{ '*Detalle de la hoja de gastos' }}
                            </span>
                </v-col>
            </v-card-title>
            <v-divider></v-divider>-->
            <v-card-text @wheel="onWheel" class="px-4 py-0" style="background-color: rgb(248, 248, 248);">
                <!--<v-container fluid @mouseenter="hover = true" @mouseleave="hover = false"> 
                    <v-row>
                        <TableWidget ref="tableWidget" :config="currentModule" :context="context" />
                    </v-row>
                </v-container>-->
                <v-container fluid full-height class="mt-4"> 
                    <v-row v-if="!apiLoading">
                        <v-col cols="12" class="mx-4 pa-0 d-flex align-center float-left" style="line-height: 25px;">
                            <v-btn icon @click="close()">
                                <v-icon color="primary">arrow_back</v-icon>
                            </v-btn>
                            <h2 v-if="currentModule.title" class="ml-4 text-truncate" style="color: #000000; font-weight: 500; font-size: 20px;">
                                {{ $t(currentModule.title, [parentData.name]) }}
                                <!--<v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="grey lighten-1" style="cursor:pointer;" class="pl-1 pointer" dense v-bind="attrs" v-on="on">info</v-icon>
                                    </template>
                                    <span>{{st(currentModule.description)}}</span>
                                </v-tooltip>-->
                            </h2>
                        </v-col>
                    </v-row>

                    <v-row v-if="apiLoading">
                        <v-col cols="12" >
                            <v-skeleton-loader
                            type="table-tbody"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <v-row v-if="!apiLoading">
                        <v-col cols="12" v-if="this.accessAllowed">
                            <EntityWrapper 
                                ref="enityWrapper" :config="currentModule" :context="context" :dialog="true" v-on:edit-action="(action) => onEditAction(item, index, action)"/>
                        </v-col>
                        <v-col cols="12" v-if="!this.accessAllowed">
                            <div class="transparent empty-state center-align">
                                <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                                    <div class="text-center">
                                        <i class="large material-icons" style="cursor: pointer;">table_chart</i>
                                        <h4>{{ $t('wkt.admin.em.main.empty-title') }}</h4>
                                        <p>{{ $t('wkt.admin.em.main.empty-subtitle') }}</p>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <!--<v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()" style="font-size: 0.9em; font-weight: 400;">
                    {{ $t('wkt.admin.common.dialog-buttons.close') }}
                </v-btn>
            </v-card-actions>-->
        </v-card>
    </v-dialog>
    </v-row>
</template>

<script> 

import EntityWrapper from "../em/EntityWrapper";
//import TableWidget from "../em/TableWidget";
import BaseModule from '../../common/BaseModule.js'
//import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'

export default {
  name: 'ExpenseSheetDetailDialog',
  mixins: [BaseModule],
  components: { 
    /*TableWidget /*/EntityWrapper
  },
  
  data() {
      return { 
        showDialog: false,
        //allModules: [],
        accessAllowed: true,
        /*showAlert: false,
        alertColor: 'error',
        alertText: '',
        alertTimeout: 3000,*/
        apiLoading: true,
        moduleLoading: false,
        moduleId: '',
        context: {},
        currentModule: {},
        parentData: null
      }
  },
   methods: {
      onWheel(event) {
         event.stopPropagation()
      },
    /*getModules() {
                if(this.moduleLoading) {
                    return;
                }
				this.apiLoading = true;
                this.moduleLoading = true;
		
				api.getModules(
                    data => {
                            this.allModules = data;
                            this.moduleLoading = false;
                            this.loadModule();
                    }, err => {
                            this.moduleLoading = false;
                            this.apiLoading = false;
                            console.log(err);
                            this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
                    });
		},
        refreshModule() {
            this.$refs.enityWrapper.refreshData();
        },*/
    loadModule() {
        
				this.apiLoading = true;
                this.moduleLoading = true;
		
				api.getModule(this.constants.MODULE_EXPENSE_SHEET_ITEM, 
                    data => {
                            let profile = gwt.getSessionProfile();
                            let sessionInformation = gwt.getSessionInformation();
                            let isSuperAdmin = sessionInformation?sessionInformation.employee.isSuperAdmin:false;
                        
                            let module = data;
                            this.currentModule = module?module:{};
                            this.currentModule.fullScreenDialog = true;

                            //revisamos permisos
                            this.accessAllowed = module && (isSuperAdmin || !this.currentModule.rolesAllowed || this.matchRole(profile,this.currentModule.rolesAllowed.split(',')));
                            
                            this.apiLoading = false;

                            document.getElementById('tidio-chat-iframe').style.display = 'none';

                            //this.showDialog = true;
                    }, err => {
                            this.moduleLoading = false;
                            this.apiLoading = false;
                            console.log(err);
                            this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
                    });
    },
	onReveal: function(payload) {				
        this.open(null, payload);
	},
    // eslint-disable-next-line no-unused-vars
    open(action, payload) {
        this.moduleId = this.constants.MODULE_EXPENSE_SHEET_ITEM;
        //this.loadModule();
        this.context = { 
            //parentModuleId: this.constants.MODULE_EXPENSE_SHEET_ITEM,
            parentModuleId: payload 
        };

        this.apiLoading = true;
        this.showDialog = true;

        api.getExpenseSheetById(payload,
            data => {
                this.apiLoading = false;
                this.parentData = data;
                this.loadModule();
            },
            err => {
                this.apiLoading = false;
                console.log(err);
                this.$emit('show-alert', { text: err.message, color: 'error', timeout: 3000 });
            }
        );

        /*let profile = gwt.getSessionProfile();

        if (!profile) { //todavía no se ha inicializado la aplicación
            return;
        }

        //let sessionInformation = gwt.getSessionInformation();
    
    if (this.mustRefresh() || !this.allModules || this.allModules.length==0) { // Primer acceso
            this.moduleId=payload.moduleId;
            this.getModules();
        } else if (this.moduleId!=payload.moduleId) { // hemos cambiado de módulo
            this.moduleId=payload.moduleId;
            this.loadModule();
            this.context=payload
        } else {
            this.context=payload; // se han actualizado los filtros globales
        }*/
        
    },
    close() {
        this.showDialog = false;
        document.getElementById('tidio-chat-iframe').style.display = 'block';
    }
    /*doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},*/
   }
};
</script>
